import GpsFixedIcon from "@mui/icons-material/GpsFixed";
import Companies from "assets/navigationIcons/companies.svg?react";
import CreditLimitRequest from "assets/navigationIcons/creditLimitRequests.svg?react";
import DashboardIcon from "assets/navigationIcons/dashboard.svg?react";
import EwalletIcon from "assets/navigationIcons/ewallet.svg?react";

import {
  INVESTOR_ALLOCATIONS,
  INVESTOR_DASHBOARD,
  INVESTOR_MONTHLY_AUM,
  INVESTOR_TRANSACTIONS,
  INVESTOR_FACTSHEET,
} from "codes";

export const INVESTOR_USER_New = (
  t: Function,
  styling: object,
  funderId?: string
) => {
  // Helper function to append funder_id to links
  const appendFunderId = (link: string) => {
    if (!funderId) return link;
    const separator = link.includes("?") ? "&" : "?";
    return `${link}${separator}funder_id=${funderId}`;
  };

  return [
    {
      title: t("dashboard"),
      icon: DashboardIcon,
      ...styling,
      link: appendFunderId(INVESTOR_DASHBOARD),
    },
    {
      title: "Active Invoices",
      icon: GpsFixedIcon,
      ...styling,
      link: appendFunderId(INVESTOR_ALLOCATIONS),
    },
    {
      title: "Transactions",
      icon: Companies,
      ...styling,
      link: appendFunderId(INVESTOR_TRANSACTIONS),
    },
    {
      title: "AUM",
      icon: CreditLimitRequest,
      ...styling,
      link: appendFunderId(INVESTOR_MONTHLY_AUM),
    },
    {
      title: "E-wallets",
      icon: EwalletIcon,
      ...styling,
      link: appendFunderId("/investor/e-wallet"),
    },
    {
      title: "Deal FactSheets",
      icon: Companies,
      ...styling,
      link: appendFunderId(INVESTOR_FACTSHEET),
    },
  ];
};
